import { z } from "zod";
import { contractSchema } from "@/types/schemas/contract";
import { axiosInstance } from "@/config/axios";
import { objectToCamel } from "ts-case-convert";
import { BadContractState } from "@/constants/errors";
import {
  REQUIRE_ATTACHMENTS_STATUS,
  REQUIRE_ATTACHMENTS_STATUS_PREVIOUS_CUSTOMER,
  ADD_INFORMATION_STATUS,
  FOR_REPAIR_STATUS,
  IS_PROCESSING_STATUS,
  OFFER_ACTIVE_STATUS,
} from "@/constants/common";

const responseSchema = z.object({
  contract: contractSchema,
  sessionKey: z.string().uuid(),
});

export const getContract = async (uuid: string) => {
  const response = await axiosInstance.get(`/contract/${uuid}`);
  const parsedResponse = responseSchema.safeParse(objectToCamel(response.data));

  if (!parsedResponse.success) {
    console.error(parsedResponse.error.issues);
    throw new Error("zod error");
  }

  if (
    parsedResponse.data.contract.state !== IS_PROCESSING_STATUS &&
    parsedResponse.data.contract.state !== ADD_INFORMATION_STATUS &&
    parsedResponse.data.contract.contractStatus !== OFFER_ACTIVE_STATUS &&
    parsedResponse.data.contract.contractStatus !== FOR_REPAIR_STATUS &&
    parsedResponse.data.contract.contractStatus !== "assigned_to_core_signed" &&
    parsedResponse.data.contract.contractStatus !== REQUIRE_ATTACHMENTS_STATUS &&
    parsedResponse.data.contract.contractStatus !== REQUIRE_ATTACHMENTS_STATUS_PREVIOUS_CUSTOMER
  ) {
    throw new Error(BadContractState);
  }

  return {
    uuid,
    ...parsedResponse.data,
  };
};
